export interface AgentConfirmationPolicyInput {
  capability: string;
  defaultConfirm: boolean;
  arguments: unknown;
  createdElementIds: ReadonlySet<string>;
}

/**
 * Mantém a proteção para itens preexistentes, mas não interrompe o projetista
 * quando o agente está somente descartando uma tentativa criada no mesmo turno.
 */
export function agentCallNeedsConfirmation(input: AgentConfirmationPolicyInput): boolean {
  if (!input.defaultConfirm) return false;
  if (input.capability !== "scene.element.delete") return true;

  const value = input.arguments && typeof input.arguments === "object"
    ? input.arguments as Record<string, unknown>
    : {};
  const elementIds = Array.isArray(value.elementIds)
    ? value.elementIds.filter((id): id is string => typeof id === "string" && Boolean(id))
    : [];
  return !elementIds.length || elementIds.some((id) => !input.createdElementIds.has(id));
}
